/** Indian-format numbers, used everywhere a figure is shown. */

export const rupee = (value: number | null | undefined, decimals = 2): string =>
  value === null || value === undefined
    ? "—"
    : `₹${value.toLocaleString("en-IN", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      })}`;

export const num = (value: number | null | undefined, decimals = 2): string =>
  value === null || value === undefined
    ? "—"
    : value.toLocaleString("en-IN", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });

export const pct = (value: number | null | undefined, decimals = 2): string =>
  value === null || value === undefined ? "—" : `${value.toFixed(decimals)}%`;

/** Reward against initial risk, shown the way the reference card does. */
export const rr = (multiple: number | null | undefined): string =>
  multiple === null || multiple === undefined ? "—" : `1:${multiple.toFixed(1)}`;

export const day = (iso: string | null | undefined): string => {
  if (!iso) return "—";
  const [y, m, d] = iso.split("-");
  return `${d}-${m}-${y}`;
};

export const signClass = (value: number | null | undefined): string =>
  value === null || value === undefined ? "" : value > 0 ? "pos" : value < 0 ? "neg" : "";

export const todayISO = (): string => new Date().toISOString().slice(0, 10);

/**
 * Short rupees for a chart axis: ₹3.6L, ₹1.2Cr, ₹45k.
 *
 * Indian scale, not thousands/millions — a lakh is how the figure is read
 * aloud, so it is how the axis should label it.
 */
export const rupeeShort = (value: number): string => {
  const sign = value < 0 ? "-" : "";
  const abs = Math.abs(value);
  if (abs >= 1e7) return `${sign}₹${(abs / 1e7).toFixed(abs >= 1e8 ? 0 : 1)}Cr`;
  if (abs >= 1e5) return `${sign}₹${(abs / 1e5).toFixed(abs >= 1e6 ? 0 : 1)}L`;
  if (abs >= 1e3) return `${sign}₹${Math.round(abs / 1e3)}k`;
  return `${sign}₹${Math.round(abs)}`;
};

/** "12 Apr 26" — compact enough for an axis, unambiguous about the month. */
export const dayShort = (iso: string): string => {
  const [y, m, d] = iso.split("-");
  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
  ];
  return `${Number(d)} ${months[Number(m) - 1]} ${y.slice(2)}`;
};
